/* src/app/main/pages/documents/airway-bill-conditions/airway-bill-conditions.component.css */
.docs-page {
  box-shadow: 0px 0px 3px #ccc;
}
.docs-page h4,
.docs-page h3 {
  font-size: 19px;
  padding: 10px 0;
}
/*# sourceMappingURL=airway-bill-conditions.component.css.map */
